import { render, staticRenderFns } from "./BorrarEmail.vue?vue&type=template&id=19a8ed62"
import script from "./BorrarEmail.vue?vue&type=script&lang=js"
export * from "./BorrarEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports